import { Box, SkeletonAvatar, SkeletonText } from '@dev-spendesk/grapes';
import { type ReactNode } from 'react';

import { SidePanelLoader } from 'src/core/common/components/SidePanel';

export const RequestCreationPanelSkeleton = ({
  title,
  onClose,
  entriesCount = 1,
}: {
  title?: ReactNode;
  onClose?: () => void;
  entriesCount?: number;
}) => {
  return (
    <SidePanelLoader
      title={
        title ?? <SkeletonText size="xxl" width="33%" className="!h-[31px]" />
      }
      onClose={onClose}
    >
      <div className="-mb-24 flex flex-col gap-16">
        {[...Array(entriesCount)].map((_, index) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            variant="secondary"
            className="flex min-h-[73px] items-center py-16"
          >
            <div className="flex w-full items-center gap-8">
              <SkeletonAvatar size="m" className="shrink-0" variant="square" />
              <SkeletonText size="xxl" width="200px" className="block" />
            </div>
          </Box>
        ))}
      </div>
    </SidePanelLoader>
  );
};
